// if open vacancies
$('.menu-item.open-vacancies-quantity a').each(function(e) {
    let nrOfVacancies = $('.page-wrapper').data('vacancies-open');

    if (typeof nrOfVacancies !== 'undefined') {
        $(this).append('<span class="quantity-orb">' + nrOfVacancies + '</span>');
    }
});
